export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticBreadcrumbs.vue?vue&type=template&id=5949740c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-breadcrumbs/VuesticBreadcrumbs.vue?vue&type=template&id=5949740c&scoped=true
// module id = tNIe
// module chunks = 41